import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsIntercomComponent } from './simple-icons-intercom.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsIntercomComponent ],
    exports:      [ SimpleIconsIntercomComponent ],
    bootstrap:    []
})
export class SimpleIconsIntercomModule {}
